import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { useAppSelector } from 'state/hooks';
import { getProjectInfoForSlug, selectUser } from 'state/userSlice';

import { useProjectSlug } from 'features/common/hooks/useProjectSlug';
import { replaceNotificationsProjectInUrl } from 'features/notifications/alertHelpers';

import { selectProject } from '../../state/workflowSlice';

import styles from './AppHeader.module.css';

export function userHasProjectAccess(user, project: string): boolean {
  const projectInfo = getProjectInfoForSlug(user, project);
  return !!projectInfo;
}

const kNoProjectSelectedValue = 'x';

export function ProjectSwitcher() {
  const user = useAppSelector(selectUser);
  const project = useAppSelector(selectProject);
  const { setSlug } = useProjectSlug();
  const navigate = useNavigate();
  const location = useLocation();
  const userHasProject = userHasProjectAccess(user, project);

  const handleChange = (event) => {
    const newProject = event.target.value;
    if (newProject === kNoProjectSelectedValue) {
      return;
    }
    setSlug(newProject);
    const newProjectUrl = replaceNotificationsProjectInUrl(
      location.pathname,
      newProject,
    );
    if (newProjectUrl) navigate(newProjectUrl, { replace: true });
  };

  useEffect(() => {
    if (user.projects !== undefined) {
      setSlug(project);
    }
  }, [user, project, setSlug]);

  if (user.projects !== undefined && project) {
    if (user.projects.length > 1) {
      return (
        <div className={styles.project_name_container}>
          <Select
            size="small"
            displayEmpty
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <p>Select a project</p>;
              }
              return selected;
            }}
            id="demo-controlled-open-select"
            value={
              userHasProject
                ? getProjectInfoForSlug(user, project)?.project_name || project
                : ''
            }
            className={styles.project_name}
            onChange={handleChange}
          >
            {user.projects?.map((option) => (
              <MenuItem key={option.project_slug} value={option.project_slug}>
                {option.project_name}
              </MenuItem>
            ))}
          </Select>
        </div>
      );
    } else {
      return (
        <h1 className={styles.project_name}>
          {getProjectInfoForSlug(user, project)?.project_name}
        </h1>
      );
    }
  } else {
    return null;
  }
}
